module.exports = __webpack_public_path__ + "img/Jim Carns.ba099ff5.jpg";